import React from "react";
import { Card, CardBody, Container, Row, Col, Button } from "reactstrap";
import { getStats } from "../../components/helpers/StatsHelpers";
import { RiArrowUpDownLine } from "react-icons/ri";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class ReorderingSongsInYourSongFlowHelp extends React.Component {
  state = { songBookCount: null };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  stepsData = [
    {
      title: "Reordering songs in your song-flow",
      description:
        "At the end of this guide you will be able to:<br/><br/>" +
        "<img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
        "rearrange the songs in your song-flow to create the right worship sequence",
    },
    {
      title: "Open your song-flow",
      description:
        "Navigate to the song-flow you would like to reorder. If you have a saved song-flow, click your name in the top-right navigation bar and select <b>View your saved song-flows</b>, then open the one you want to edit." +
        "<br/><br/>If you have just built a song-flow, you will already be on the song-flow page.",
    },
    {
      title: "Drag a song to a new position",
      description:
        "Each song in your song-flow can be dragged into a new position. Click and hold on a song, then drag it up or down to where you would like it to appear. Release to drop it into place.",
    },
    {
      title: "Use the arrow buttons",
      description:
        "If dragging is not convenient, you can also use the up and down arrow buttons displayed next to each song. " +
        "Click the up arrow to move a song one position higher, or the down arrow to move it one position lower. " +
        "The arrows are greyed out when a song is already at the top or bottom of the list.",
    },
    {
      title: "Review the order",
      description:
        "Once you are happy with the sequence, review the song-flow from top to bottom to make sure it flows as intended for your service.",
    },
    {
      title: "Save your changes",
      description:
        "If you have a paid account, click <b>Save</b> to save the updated order to your account. " +
        "Free accounts can reorder songs within a session, but the changes will not be saved once you leave the page." +
        "<br/><br/>To upgrade your account, visit the <a href='/register/choose-your-plan'>plans page</a>.",
    },
    {
      title: "What's next",
      description:
        "Your song-flow is now in the right order for your service." +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/sharing-a-song-flow'>Share your song-flow with your team</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/saving-and-managing-your-song-flows'>Save and manage your song-flows</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> View our other <a href='/help'>help articles</a> for more guidance.",
      image: "/help-images/well-done.png",
      enlargeable: false,
    },
  ];

  render() {
    return (
      <>
        <SeoHelper
          uri="/help/reordering-songs-in-your-song-flow"
          title="Reordering songs in your song-flow | Help | The Worship Bible"
          description="How to drag and rearrange songs in your curated song-flow to create the right worship flow."
        />
        <div className="position-relative">
          <section className="section section-lg section-shaped pb-250">
            <div className="shape shape-style-1 shape-default">
              <span/><span/><span/><span/><span/><span/><span/><span/><span/>
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows{" "}<span>help</span>
                    </h1>
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew">
              <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
              </svg>
            </div>
          </section>
        </div>
        <section className="section section-lg pt-lg-0 mt--200">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="12">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <Row className="mt-3">
                          <Col>
                            <div className="d-flex align-items-center mb-3">
                              <RiArrowUpDownLine color="#5e72e4" size="24" className="mr-2"/>
                              <h2 style={{fontSize: "1rem"}} className="text-primary mb-0">Reordering songs in your song-flow</h2>
                            </div>
                          </Col>
                          <Col md="3" xs="12">
                            <Button block type="button" className="mb-2" color="white" href="/help">
                              <span className="btn-inner--text">Back to help</span>
                            </Button>
                          </Col>
                        </Row>
                        <InstructionsWizard stepsData={this.stepsData}/>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default ReorderingSongsInYourSongFlowHelp;
